module.exports = __webpack_public_path__ + "static/media/pie2.5c4f485c.jpg";